// Tool details data - separated to avoid babel plugin issues
export const toolDetails = {
  1: {
    summary: 'Burp Suite is the industry-standard tool for web application security testing. This comprehensive demo series covers everything from basic proxy usage to advanced scanner customization.',
    topics: [
      'Proxy Fundamentals',
      'Target Scope Configuration',
      'Intruder Attack Types',
      'Scanner Customization',
      'Extension Development',
      'Reporting Features'
    ],
    suitableFor: [
      'Web developers',
      'Security testers',
      'Bug bounty hunters',
      'QA professionals'
    ],
    benefits: [
      'Master professional tooling',
      'Increase testing efficiency',
      'Find more vulnerabilities',
      'Professional reporting skills'
    ],
  },
};
